/* ============================================================
   THREE OH SIX · PDP-Vergleich v2 (sections/pdp-comparison.liquid)
   1. Scroll-Entrance + Count-up, fail-visible:
      - CSS versteckt nur unter .cmp--js, diese Klasse setzt erst dieses Skript.
      - IntersectionObserver (threshold 0.2) setzt .is-in, danach Count-up.
      - Notbremse nach 2500 ms: liegt die Section im Viewport oder ist der Tab
        verborgen und hat der Observer trotzdem nicht ausgeloest, wird .cmp--js
        wieder entfernt (transitionslos sichtbar). Muster aus
        sections/collection-benefit-tiles.liquid.
      - Count-up zaehlt die erste Ganzzahl im Text von 0 hoch, Rest bleibt,
        Endzustand ist immer der Originaltext.
   2. Aufklappbare Infos: .cmp__row-toggle schaltet aria-expanded und das
      hidden-Attribut der Detailzeile (aria-controls).
   3. CTA [data-cmp-cta]: scrollt zum Kaufbereich der PDP und laesst den
      Kaufen-Button kurz pulsieren (.cmp-pulse, CSS in section-pdp-comparison.css).
      Formular: das erste /cart/add-Formular (zuerst in der Main-Section), das
      einen Submit-Button enthaelt. Das versteckte Raten-Formular
      (product-form-installment-...) steht im DOM davor und hat keinen Button.
   ============================================================ */
(function () {
  'use strict';
  if (window.__tosCmpLoaded) return;
  window.__tosCmpLoaded = true;

  var DURATION = 900;
  var RESCUE_DELAY = 2500;
  var RESCUE_INTERVAL = 1500;
  var PULSE_DELAY = 700;
  var PULSE_TIME = 1200;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function countUp(root) {
    if (reducedMotion()) return;
    var els = root.querySelectorAll('[data-count]');
    Array.prototype.forEach.call(els, function (el) {
      var original = el.textContent;
      var match = original.match(/\d+/);
      if (!match) return;
      var target = parseInt(match[0], 10);
      if (!target) return;
      var before = original.slice(0, match.index);
      var after = original.slice(match.index + match[0].length);
      var start = null;
      var finished = false;

      function finish() {
        if (finished) return;
        finished = true;
        el.textContent = original;
      }

      function frame(ts) {
        if (finished) return;
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / DURATION);
        if (p >= 1) {
          finish();
          return;
        }
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = before + Math.round(target * eased) + after;
        window.requestAnimationFrame(frame);
      }

      window.requestAnimationFrame(frame);
      // Sicherheitsnetz: Originaltext garantiert, auch wenn rAF pausiert
      window.setTimeout(finish, DURATION + 400);
    });
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh && r.bottom > 0;
  }

  /* ---------- Aufklappbare Infos ---------- */
  function toggleRow(btn) {
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
  }

  /* ---------- CTA: zum Kaufbereich ---------- */
  function findBuyForm() {
    var sels = [
      '.shopify-section[id$="__main"] form[action*="/cart/add"]',
      'form[action*="/cart/add"]'
    ];
    for (var s = 0; s < sels.length; s++) {
      var forms = document.querySelectorAll(sels[s]);
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('button[name="add"], [type="submit"]')) return forms[i];
      }
    }
    return null;
  }

  function goBuy(root) {
    var behavior = reducedMotion() ? 'auto' : 'smooth';
    var form = findBuyForm();
    if (!form) {
      window.scrollTo({ top: 0, behavior: behavior });
      return;
    }
    form.scrollIntoView({ behavior: behavior, block: 'center' });

    var btn = form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]');
    if (!btn) return;
    var accent = '';
    try {
      accent = window.getComputedStyle(root).getPropertyValue('--accent').trim();
    } catch (e) {}

    window.setTimeout(function () {
      if (accent) btn.style.setProperty('--cmp-pulse', accent);
      btn.classList.remove('cmp-pulse');
      void btn.offsetWidth; // Animation neu starten, falls mehrfach geklickt
      btn.classList.add('cmp-pulse');
      window.setTimeout(function () {
        btn.classList.remove('cmp-pulse');
      }, PULSE_TIME);
    }, PULSE_DELAY);
  }

  function bindUi(root) {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var row = t.closest('.cmp__row-toggle');
      if (row && root.contains(row)) {
        toggleRow(row);
        return;
      }
      var cta = t.closest('[data-cmp-cta]');
      if (cta && root.contains(cta)) {
        e.preventDefault();
        goBuy(root);
      }
    });
  }

  /* ---------- Init ---------- */
  function init(root) {
    if (!root || root.hasAttribute('data-cmp-init')) return;
    root.setAttribute('data-cmp-init', '');

    bindUi(root);

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      root.classList.add('is-in');
      return;
    }

    root.classList.add('cmp--js');

    var done = false;
    var io = null;
    var rescueTimer = null;

    function stopRescue() {
      if (rescueTimer) {
        window.clearTimeout(rescueTimer);
        rescueTimer = null;
      }
    }

    function reveal() {
      if (done) return;
      done = true;
      stopRescue();
      if (io) io.disconnect();
      root.classList.add('is-in');
      countUp(root);
    }

    function rescue() {
      rescueTimer = null;
      if (done) return;
      if (document.hidden || inViewport(root)) {
        done = true;
        if (io) io.disconnect();
        root.classList.remove('cmp--js');
        root.classList.add('is-in');
        return;
      }
      rescueTimer = window.setTimeout(rescue, RESCUE_INTERVAL);
    }

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal();
          break;
        }
      }
    }, { threshold: 0.2 });
    io.observe(root);

    rescueTimer = window.setTimeout(rescue, RESCUE_DELAY);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-cmp]:not([data-cmp-init])');
    Array.prototype.forEach.call(list, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
